/**
 * @name Top
 */
import React from 'react'
import styled from 'styled-components'
import {Flex, Image, ImageButton, Text, useRoutes} from 'lib'
import {top_company_logo, top_logo} from 'assets/svg'
import {MENU} from 'config'

export default function Top() {
  // hooks
  const {navigate} = useRoutes()
  //*--------------------------------------------------*
  return (
    <Content>
      {/* 전체메뉴 */}
      <Flex className="wrap" alignitems="center" justifycontent="space-between">
        <Flex alignitems="center">
          <ImageButton
            onClick={() => {
              navigate(MENU.NOTICE)
            }}
            src={top_company_logo}
          />
          <Text mode={'Caption_LR'} label="현대 백화점 무역센터점" color="#183B56" style={{marginLeft: 16}} />
        </Flex>
        <Image src={top_logo} />
      </Flex>
    </Content>
  )
}
//*--------------------------------------------------*
const Content = styled.div`
  display: block;
  .wrap {
    width: 100%;
    height: 84px;
    padding: 0 40px;
  }
`
